import cx from 'classnames';
import { AllHTMLAttributes, ElementType, forwardRef } from 'react';

import { sprinkles, Sprinkles } from '@/styles/vanilla/sprinkles.css';

export interface BoxProps
  extends Omit<
      AllHTMLAttributes<HTMLElement>,
      'content' | 'height' | 'translate' | 'color' | 'width' | 'cursor'
    >,
    Sprinkles {
  component?: ElementType;
}

export const Box = forwardRef<any, BoxProps>(function Box(
  {
    component: Component = 'div',
    className,
    boxShadow,
    padding,
    paddingX,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    margin,
    marginX,
    marginY,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    display,
    alignItems,
    justifyContent,
    flexDirection,
    flexWrap,
    flexGrow,
    flexShrink,
    borderColor,
    borderRadius,
    borderStyle,
    borderWidth,
    position,
    top,
    bottom,
    left,
    right,
    inset,
    background,
    color,
    width,
    height,
    zIndex,
    opacity,
    pointerEvents,
    cursor,
    textAlign,
    textTransform,
    textDecoration,
    maxWidth,
    minWidth,
    transition,
    overflow,
    fontSize,
    fontWeight,
    lineHeight,
    ...restProps
  }: BoxProps,
  ref
) {
  const atomClasses = cx(
    sprinkles({
      boxShadow,
      padding,
      paddingX,
      paddingY,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      margin,
      marginX,
      marginY,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      display,
      alignItems,
      justifyContent,
      flexDirection,
      flexWrap,
      flexGrow,
      flexShrink,
      borderColor,
      borderRadius,
      borderStyle,
      borderWidth,
      position,
      top,
      bottom,
      left,
      right,
      inset,
      background,
      color,
      width,
      height,
      zIndex,
      opacity,
      pointerEvents,
      cursor,
      textAlign,
      textTransform,
      textDecoration,
      maxWidth,
      minWidth,
      transition,
      overflow,
      fontSize,
      fontWeight,
      lineHeight,
    }),
    className
  );

  return <Component ref={ref} className={atomClasses} {...restProps} />;
});
